const SET_AGENTS_LIST = (state, payload) => { state.agentsList = payload; }
const RESET_AGENTS_LIST = (state, payload) => { state.agentsList = payload; }

const SET_CURRENT_AGENT = (state, payload) => { state.currentAgent = payload; }
const RESET_CURRENT_AGENT = (state, payload) => { state.currentAgent = payload; }

const SET_PRODUCT_LIST = (state, payload) => { state.productList = payload }
const RESET_PRODUCT_LIST = (state) => { state.productList = [] }

export default {
  SET_AGENTS_LIST,
  RESET_AGENTS_LIST,
  SET_CURRENT_AGENT,
  RESET_CURRENT_AGENT,
  SET_PRODUCT_LIST,
  RESET_PRODUCT_LIST,
}

